<template>
  <b-container
    style="padding-right: 25px !important; padding-left: 25px !important"
  >
    <div class="wrapper">
      <div class="news-list">
        <router-link
          class="list-item"
          v-for="(item, index) in newList"
          :key="index"
          :to="`/forum/news/detail?id=${item.id}`"
        >
          <div class="text-part">
            <div class="date">
              <div class="date-title">
                {{ item.categoryName }}
              </div>
              <div class="date-time">
                {{ String(item.createTime).split(" ")[0] }}
              </div>
            </div>
            <div class="content pl-3 pr-3">
              <div class="content-title">
                {{ item.title }}
              </div>
              <div class="content-text">
                {{ getSimpleText(item.content) }}
              </div>
            </div>
          </div>
          <div class="img-part img-wrap img-hovor">
            <img
              width="100%"
              height="100%"
              :src="item.titleImg || item.srcFileName"
            />
          </div>
        </router-link>
        <router-link
          class="mini-item"
          v-for="(item, index) in newList"
          :key="'.' + index"
          :to="`/forum/news/detail?id=${item.id}&categoryId=${typeId}`"
        >
          <div class="part">
            <div class="content-title">
              {{ item.title }}
            </div>
            <div class="content">
              <div class="content-txt">
                <div class="content-text">
                  {{ getSimpleText(item.content) }}
                </div>
                <span class="date-title">
                  {{ item.categoryName }}
                </span>
                <span class="date-time">
                  {{ String(item.createTime).split(" ")[0] }}
                </span>
              </div>
              <div class="img-part img-wrap img-hovor">
                <img
                  width="100%"
                  height="100%"
                  :src="item.titleImg || item.srcFileName"
                />
              </div>
            </div>
          </div>
        </router-link>
        <b-pagination
          class="pt-5 pb-5"
          align="center"
          :hide-goto-end-buttons="true"
          :hide-ellipsis="true"
          v-model="currentPage"
          :total-rows="totalRow"
          :per-page="perPage"
          @input="chagePage"
        >
        </b-pagination>
      </div>
    </div>
  </b-container>
</template>
<script>
export default {
  data() {
    return {
      totalRow: 0,
      typeId: "",
      newList: [],
      currentPage: 10, //当前页
      perPage: 12, //每页十条
      year: "",
    };
  },
  created() {},
  watch: {
    $route: {
      handler(to) {
        this.typeId = to.query.typeId;
        this.year = to.query.year;
        console.log("$route", this.typeId);
        this.getList();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    getList() {
      this.newList = [];
      this.paginnatFlag = false;
      this.$forumApi
        .newsPageList({
          page: this.currentPage,
          limit: this.perPage,
          categoryId: this.typeId,
          year: this.year,
        })
        .then((res) => {
          if (res.code == 200) {
            this.paginnatFlag = true;
            console.log("res.data.records.length-----", res.data.records);
            this.newList = res.data.records;
            this.totalRow = res.data.total;
           
          }
        });
    },
    getSimpleText(html) {
      var re1 = new RegExp("<.+?>", "g"); //匹配html标签的正no则表达式，"g"是搜索匹配多个符合的内容
      var msg = html.replace(re1, ""); //执行替换成空字符
      var re2 = new RegExp("&nbsp;", "g");
      var newmsg = msg.replace(re2, "");
      return newmsg;
    },
    chagePage(index) {
      this.currentPage = index;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper::v-deep {
  .page-link {
    font-size: 1rem;
    color: #4a4a4a;
  }

  .page-item.active .page-link {
    z-index: 3;
    color: #fff;
    background-color: #cfaf75;
    border-color: #cfaf75;
  }

  .page-link:focus {
    box-shadow: none;
    color: #fff !important;
  }

  .news-list {
    margin-top: 2rem;

    a {
      text-decoration: none;
    }

    .list-item:hover {
      background: #f7f7f7;
    }

    .list-item {
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      padding: 2rem 0 2rem 0;
      cursor: pointer;
      text-decoration: none;
      border-bottom: 0.1rem solid #ebebeb;
      box-sizing: border-box;

      .text-part {
        display: flex;
        flex-direction: column-reverse;
        flex: 1.7;
        justify-content: space-between;
        padding: 0.5rem;

        .date {
          display: flex;
          padding-left: 2rem;

          .date-title {
            padding-left: 1rem;
            font-size: 1rem;
            color: #333333;
            min-height: 2rem;
          }

          .date-time {
            margin-left: 2rem;
            font-size: 1rem;
            color: #999999;
          }
        }

        .content {
          .content-title {
            font-size: 1.4rem;
            color: #4a4a4a;
            overflow: hidden;
            text-overflow: ellipsis;
            height: 2rem;
          }

          .content-text {
            height: 8rem;
            margin-top: 1rem;
            font-size: 1rem;
            color: #666666;
            overflow: hidden;
            line-height: 1.7rem;
          }
        }
      }

      .img-part {
        flex: 0.8;
        height: 8rem;
      }
    }
  }

  @media (min-width: 768px) {
    .mini-item {
      display: none;
    }

    .news-list {
      .list-item {
        display: flex;
        flex-direction: row;
        align-items: unset;

        .text-part {
          display: flex;
          flex-direction: row;
          margin: 2rem auto;

          .date {
            display: block;
            flex: 0.9;

            .date-time {
              margin-left: 0rem;
              font-size: 1rem;
              color: #999999;
            }

            .date-title {
              padding: 0;
              font-size: 1.2rem;
            }
          }

          .content {
            flex: 3;
          }
        }

        .img-wrap {
          margin-right: 2rem;
          min-height: 14rem;
          max-width: 21rem;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .list-item {
      display: none !important;
    }

    .news-list {
      margin-top: 0rem;
    }

    .mini-item {
      display: block;
      padding: 3rem 0rem 4.3rem 0rem;
      border-bottom: 1px solid #ebebebde;

      .content {
        display: flex;

        .content-text {
          height: 5rem;
          line-height: 1.7rem;
          width: 12rem;
          color: #666666;
          overflow: hidden;
          font-size: 12px;
          margin-bottom: 0.5rem;
        }
      }

      .date-title {
        font-size: 13px;
        color: #4a4a4a;
      }

      .date-time {
        font-size: 12px;
        margin-left: 12px;
        color: #999999;
      }

      .content-title {
        font-size: 14px;
        color: #4a4a4a;
        margin-bottom: 2.8rem;
      }

      .content-txt {
        flex: 3;
      }

      .img-wrap {
        flex: 1.7;
        width: 100%;
        height: 6rem;
        overflow: hidden;
        border-radius: 9px;
        margin: 0;
      }
    }
  }
}
</style>